import React, {useMemo} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {useIntl} from "react-intl";
import {FLAGS, FlagName, ProductEditValues} from "@/data/entities/menuEditor";
import {label} from "@/utils/LabelUtils";
import MultiSelectCombobox, {MultiSelectOption} from "@widgets/input/combobox/MultiSelectCombobox";

const ALCOHOLIC: FlagName = "alcoholic";

type Props = {
    disabled: boolean,
};

/**
 * Allergens, taste and dietary flags. `alcoholic` has its own field.
 */
const FlagsField = ({disabled}: Props) => {
    const intl = useIntl();
    const {control, setValue} = useFormContext<ProductEditValues>();
    const value: FlagName[] = useWatch({control, name: "flags"});
    const options: MultiSelectOption<FlagName>[] = useMemo(
        () => FLAGS
            .filter(flag => flag !== ALCOHOLIC)
            .map(flag => ({value: flag, displayValue: intl.formatMessage({id: `flag.${flag}`})})),
        [intl]);

    return (
        <MultiSelectCombobox<FlagName>
            label={label("allergensAndDiet", false)}
            options={options}
            value={value.filter(flag => flag !== ALCOHOLIC)}
            onChange={(flags: FlagName[]) => setValue(
                "flags",
                [
                    // Keep `alcoholic`: it's set with its own field
                    ...(value.includes(ALCOHOLIC) ? [ALCOHOLIC] : []),
                    ...flags,
                ],
                {shouldDirty: true},
            )}
            disabled={disabled}
        />
    );
};

export default FlagsField;